const MAX_10_EXPONENT = Math.floor(Math.log10(Number.MAX_VALUE));
const MIN_10_EXPONENT = Math.ceil(Math.log10(Number.MIN_VALUE));

// Math.pow(10, exponent) is not imprecise for some exponents.
// Number(`1e${MIN_10_EXPONENT + i}`)) is good, but it's an awful
// way to compute it, so we precompute it for all powers of 10 in
// the float64 range.
const POWERS_OF_10 = new Array(MAX_10_EXPONENT - MIN_10_EXPONENT + 1)
  .fill(0)
  .map((_, i) => Number(`1e${MIN_10_EXPONENT + i}`));

export function pow10(exponent: number) {
  // Fall back to Math.pow(10, exponent) for exponents that are not
  // in the precomputed array (i.e. non-integer or out of range).
  return POWERS_OF_10[exponent - MIN_10_EXPONENT] ?? Math.pow(10, exponent);
}
